module.exports = __webpack_public_path__ + "static/media/BASIS-WATERNIVEAU_01.2fb127c3.apng";